import { render, staticRenderFns } from "./jifenForm.vue?vue&type=template&id=44a2a918&scoped=true"
import script from "./jifenForm.vue?vue&type=script&lang=js"
export * from "./jifenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a2a918",
  null
  
)

export default component.exports